export default "__VITE_ASSET__CNd6VZnO__"